import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withKeys as _withKeys, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-827a5176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nerv-section" }
const _hoisted_2 = { class: "ops-head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-section-label" }, "Sec 02 // Operator", -1))
const _hoisted_4 = { class: "ops-line" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-status nerv-lcd" }, "Link active", -1))
const _hoisted_6 = { class: "nerv-caption" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"nerv-panel nerv-bracket ident\" data-v-827a5176><div class=\"ident-main\" data-v-827a5176><h1 class=\"nerv-heading nerv-heading-xl\" data-v-827a5176>Daniil Demidov</h1><p class=\"nerv-lede\" data-v-827a5176>AI Engineer · Applied AI and agent infrastructure</p><a class=\"nerv-btn ident-resume\" href=\"/Daniil-Demidov-Resume.pdf\" download data-v-827a5176> Download resume (PDF) </a><p class=\"nerv-microcopy ident-blurb\" data-v-827a5176> Ships production LLM and agent systems end to end: prompt design, tool calling, evals, integration and deployment. Eleven years building multi-tenant SaaS across TypeScript, .NET, Go and Python, including Fraud and Security engineering at a digital banking platform serving 17M+ end users. </p></div><dl class=\"ident-data\" data-v-827a5176><div class=\"nerv-datarow\" data-v-827a5176><dt class=\"nerv-datarow-key\" data-v-827a5176>Location</dt><dd class=\"nerv-datarow-value\" data-v-827a5176>Plano, Texas (Dallas metro)</dd></div><div class=\"nerv-datarow\" data-v-827a5176><dt class=\"nerv-datarow-key\" data-v-827a5176>Phone</dt><dd class=\"nerv-datarow-value\" data-v-827a5176><a href=\"tel:+12149457067\" class=\"link\" data-v-827a5176>214-945-7067</a></dd></div><div class=\"nerv-datarow\" data-v-827a5176><dt class=\"nerv-datarow-key\" data-v-827a5176>Email</dt><dd class=\"nerv-datarow-value\" data-v-827a5176><a href=\"mailto:daniil@dev1consulting.com\" class=\"link\" data-v-827a5176>daniil@dev1consulting.com</a></dd></div><div class=\"nerv-datarow\" data-v-827a5176><dt class=\"nerv-datarow-key\" data-v-827a5176>LinkedIn</dt><dd class=\"nerv-datarow-value\" data-v-827a5176><a href=\"https://www.linkedin.com/in/DaniilDemidov\" target=\"_blank\" rel=\"noopener\" class=\"link\" data-v-827a5176> /in/DaniilDemidov </a></dd></div><div class=\"nerv-datarow\" data-v-827a5176><dt class=\"nerv-datarow-key\" data-v-827a5176>GitHub</dt><dd class=\"nerv-datarow-value\" data-v-827a5176><a href=\"https://github.com/iCodeWebApps\" target=\"_blank\" rel=\"noopener\" class=\"link\" data-v-827a5176> /iCodeWebApps </a></dd></div></dl></div>", 1)
const _hoisted_8 = { class: "nerv-section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-section-label" }, "Sec 02.1 // Summary", -1))
const _hoisted_10 = { class: "summary" }
const _hoisted_11 = { class: "nerv-section" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-section-label" }, "Sec 02.2 // Core expertise", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "nerv-heading nerv-heading-lg section-title" }, "Technical skills", -1))
const _hoisted_14 = { class: "skill-groups" }
const _hoisted_15 = { class: "nerv-data-label" }
const _hoisted_16 = { class: "chips" }
const _hoisted_17 = { class: "nerv-section" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nerv-section-label" }, "Sec 02.3 // Service record", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "nerv-heading nerv-heading-lg section-title" }, "Professional experience", -1))
const _hoisted_20 = { class: "record" }
const _hoisted_21 = ["onClick", "onKeydown"]
const _hoisted_22 = { class: "nerv-data-label" }
const _hoisted_23 = { class: "nerv-heading nerv-heading-md" }
const _hoisted_24 = { class: "nerv-caption" }
const _hoisted_25 = { class: "job-body" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<section class=\"nerv-section\" data-v-827a5176><span class=\"nerv-section-label\" data-v-827a5176>Sec 02.4 // Education</span><div class=\"nerv-panel nerv-bracket education\" data-v-827a5176><h3 class=\"nerv-heading nerv-heading-md\" data-v-827a5176>Bachelor of Science in Mathematics &amp; Computer Science</h3><p class=\"nerv-microcopy\" data-v-827a5176>Texas Tech University, Lubbock, TX</p></div></section>", 1)
const _hoisted_27 = { class: "nerv-section" }
const _hoisted_28 = { class: "about-cta" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nerv-btn",
  href: "/Daniil-Demidov-Resume.pdf",
  download: ""
}, "Download resume (PDF)", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.linkLine), 1)
        ])
      ]),
      _hoisted_7
    ]),
    _createElementVNode("section", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary, (line) => {
          return (_openBlock(), _createElementBlock("p", {
            key: line,
            class: "nerv-body"
          }, _toDisplayString(line), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (group) => {
          return (_openBlock(), _createElementBlock("div", {
            key: group.group,
            class: "skill-group"
          }, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(group.group), 1),
            _createElementVNode("ul", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item,
                  class: "chip"
                }, _toDisplayString(item), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_17, [
      _hoisted_18,
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experience, (job, i) => {
          return (_openBlock(), _createElementBlock("article", {
            key: job.company,
            class: "nerv-panel job"
          }, [
            _createElementVNode("header", {
              class: "job-head",
              onClick: ($event: any) => (_ctx.toggle(i)),
              role: "button",
              tabindex: "0",
              onKeydown: [
                _withKeys(($event: any) => (_ctx.toggle(i)), ["enter"]),
                _withKeys(_withModifiers(($event: any) => (_ctx.toggle(i)), ["prevent"]), ["space"])
              ]
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(job.duration), 1),
                _createElementVNode("h3", _hoisted_23, _toDisplayString(job.company), 1),
                _createElementVNode("p", _hoisted_24, _toDisplayString(job.position) + " · " + _toDisplayString(job.location), 1)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["expand", { open: _ctx.isOpen(i) }]),
                "aria-hidden": "true"
              }, null, 2)
            ], 40, _hoisted_21),
            _withDirectives(_createElementVNode("ul", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.description, (line) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: line,
                  class: "nerv-body-sm"
                }, _toDisplayString(line), 1))
              }), 128))
            ], 512), [
              [_vShow, _ctx.isOpen(i)]
            ])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_26,
    _createElementVNode("section", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "nerv-btn nerv-btn-ghost"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Start a conversation")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}